module.exports = __webpack_public_path__ + "img/navigator_bar_upload.11dc429f.svg";